import * as customLibs from '@vfdp-customs/customs-libs';
export const validateImageRequirements = (file, image, requirements) => {
  const cl = new customLibs.default();
  const imageRequirements = requirements || cl.imageRequirements;
  const { imageStatus } = new cl.Libs.ValidateImage(file,image,imageRequirements);
  const isValidImage = (imageStatus.imageType && imageStatus.imageDimensions &&imageStatus.imageSize);
  return {
    imageStatus, isValidImage
  }
}